import React, { useEffect, useState, useCallback } from "react";
import LandingPagePanelComponent from "./landingPagePanel.component";
import { connect, useSelector, useDispatch } from "react-redux";
import { getProductPage, updateProductPage } from "../../../redux/action/products.action";
import { selectLoading } from "modules/notification";
import { setEditorMode } from "modules/product-mgmt/redux/slice/productPage.slice";
import { getConsumerPageSetting } from "modules/account/redux";
import { resetAvailableSurveys } from "modules/survey/redux/slice";
import { fetchTemplateDropdown } from "../../../redux/action/template.action";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";
import {AccessRights} from "../../../../../lib/constants/accessRights";

function LandingPagePanelContainer({
  enableEditorMode,
  disableEditorMode,
  getProductPage,
  isLoading,
  isError,
  createdAt,
  updatedAt,
  isEditorMode,
  getConsumerPageSetting,
  template,
  templateAfter,
  hasCampaignAccess,
  hasSurveyAccess,
  hasLuckyDrawAccess,
  hasLuckyDrawV2Access,
  hasInstantLuckyDrawAccess,
  hasLoyaltyProgramAccess,
  hasProductEditAccessRight,
  fetchTemplateDropdown,
  hasLandingPageEditAccessRight,
}) {
  const [hasLoaded, setHasLoaded] = useState(false);
  const dispatch = useDispatch()
  const lang = useSelector(state => state.constant.languages);

  useEffect(() => {
    dispatch(fetchTemplateDropdown());

    return () => {
      dispatch(resetAvailableSurveys());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadProduct = useCallback(() => {
    getProductPage();
    getConsumerPageSetting();
    setHasLoaded(true);
  }, [getProductPage, getConsumerPageSetting]);

  useEffect(() => {
    loadProduct();
  }, [loadProduct]);

  const handleNavigateEditor = () => {
    if (hasProductEditAccessRight) {
      enableEditorMode();
    }
  };

  const handleCancel = () => {
    if (hasProductEditAccessRight) {
      disableEditorMode()
      getProductPage();
    }
  }

  const handleSubmit = () => {
    dispatch(updateProductPage())
    disableEditorMode()
  }

  return (
    <LandingPagePanelComponent
      hasProductEditAccessRight={hasProductEditAccessRight}
      handleNavigateEditor={handleNavigateEditor}
      isLoading={isLoading}
      isError={isError}
      hasLoaded={hasLoaded}
      createdAt={createdAt}
      updatedAt={updatedAt}
      isEditorMode={isEditorMode}
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      lang={lang}
      template={template}
      templateAfter={templateAfter}
      hasLandingPageEditAccessRight={hasLandingPageEditAccessRight}
    />
  );
}

const mapStateToProps = state => ({
  isError: state.productPage.error,
  isLoading: selectLoading(state, getProductPage.typePrefix) || selectLoading(state, fetchTemplateDropdown.typePrefix),
  createdAt: state.productPage.pageCreatedAt,
  updatedAt: state.productPage.pageUpdatedAt,
  isEditorMode: state.productPage.isEditorMode,
  template: state.productPage.template,
  templateAfter: state.productPage.templateAfter,
  hasCampaignAccess:
    canAccess(state, AccessRights.Survey.LISTING_READ) ||
    canAccess(state, AccessRights.Campaign.LUCKY_DRAW_READ) ||
    canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_READ) ||
    canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_READ) ||
    canAccess(state, AccessRights.LoyaltyProgram.LOYALTY_POINT_READ),
  hasSurveyAccess: canAccess(state, AccessRights.Survey.LISTING_READ),
  hasLuckyDrawAccess: canAccess(state, AccessRights.Campaign.LUCKY_DRAW_READ),
  hasLuckyDrawV2Access: canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_READ),
  hasInstantLuckyDrawAccess: canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_READ),
  hasLoyaltyProgramAccess: canAccess(state, AccessRights.LoyaltyProgram.LOYALTY_POINT_READ),
  hasProductEditAccessRight: canAccess(state, AccessRights.Product.LISTING_UPDATE),
  hasLandingPageEditAccessRight: canAccess(state, AccessRights.Product.LANDING_PAGE_WRITE)
});

const mapDispatchToProps = dispatch => ({
  fetchTemplateDropdown: () => dispatch(fetchTemplateDropdown()),
  enableEditorMode: () => dispatch(setEditorMode(true)),
  disableEditorMode: () => dispatch(setEditorMode(false)),
  getProductPage: () => dispatch(getProductPage()),
  getConsumerPageSetting: () => dispatch(getConsumerPageSetting())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LandingPagePanelContainer);
